export const AT_ACTIVE_NOTIFICATION_UPDATE = 'ACTIVE_NOTIFICATION_UPDATE';
export const AT_RECENT_NOTIFICATION_UPDATE = 'RECENT_NOTIFICATION_UPDATE';
